import React, { FC, memo } from "react";
import { DatePicker } from "antd";
import dayjs, { Dayjs } from "dayjs";
import { GroupBlockEntityType } from "../../../../configMap";
import useEditEntityDate from "../../hooks/useEditEntityDate";

type EditEntityDateProps = {
  entityType: GroupBlockEntityType;
  documentId: string;
  annotationId: string;
  defaultValue: Dayjs | null;
  groupBlockIndex: number;
  format: string | null;
  isTableMode: boolean;
};

const EditEntityDate: FC<EditEntityDateProps> = ({
  entityType,
  documentId,
  annotationId,
  defaultValue,
  groupBlockIndex,
  format,
  isTableMode,
}: EditEntityDateProps) => {
  const { dateFormat, handleChange, handleEnter, handleCancel } =
    useEditEntityDate({
      entityType,
      documentId,
      annotationId,
      defaultValue,
      groupBlockIndex,
      format,
      isTableMode,
    });

  if (isTableMode) {
    return (
      <div className="edit-entity--table edit-entity-date">
        <div
          className="date-picker-wrapper"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <DatePicker
            size={"small"}
            onChange={handleChange}
            defaultValue={
              defaultValue?.isValid() ? dayjs(defaultValue) : dayjs()
            }
            format={dateFormat}
            allowClear={false}
            open={true}
            picker={"week"}
            autoComplete="off"
          />
        </div>
        <span className="edit-actions">
          <i className="bi bi-slash-circle cancel" onMouseDown={handleCancel} />
          <i className="bi bi-check-lg submit" onMouseDown={handleEnter} />
        </span>
      </div>
    );
  }

  return (
    <span className="edit-entity--side edit-entity-date">
      <div
        className="date-picker-wrapper"
        onClick={(e) => {
          console.log(e);
          e.stopPropagation();
        }}
      >
        <DatePicker
          size={"small"}
          onChange={handleChange}
          defaultValue={defaultValue?.isValid() ? dayjs(defaultValue) : dayjs()}
          format={dateFormat}
          allowClear={false}
          open={true}
          picker={"week"}
          autoComplete="off"
        />
      </div>
      <span className="edit-entity-actions">
        <i className="bi bi-slash-circle cancel" onMouseDown={handleCancel} />
        <i className="bi bi-check-lg submit" onMouseDown={handleEnter} />
      </span>
    </span>
  );
};

export default memo(EditEntityDate);
